<template>
  <div class="form-group text-center my-3">
    <a href="#" class="btn btn-outline-secondary shadow-sm border-light px-3" @click.prevent="$emit('more', 7)">
      <i class="fa fa-calendar mr-1 opacity-7" />
      Select Another Day
    </a>
  </div>
</template>

<script charset="utf-8">
export default {
  name: "LoadMore",
};
</script>
